import React from "react";
import { observer } from "mobx-react";
import {
    Checkbox,
    Grid,
    Button,
    Input,
    Chip,
    ListItem,
    ListItemText,
} from "@material-ui/core";
import { FixedSizeList } from 'react-window';
import Abstract from "../Abstract";
import Store from "./Store";
import autoBind from "auto-bind";
import { StyledTooltip } from "app/common/utils/StyledTooltip";
import styled from "styled-components";

class TextFilter extends Abstract {
    constructor(...args) {
        super(...args);

        this.store = new Store(...args);
        this.loadStore();
        this.props.onComponentLoaded(this.store);
        autoBind(this);
    }

    handleChange(e) {
        const { selectedOptions } = this.store

        if (e.target.checked) {
            selectedOptions.add(e.target.value)
        } else {
            selectedOptions.delete(e.target.value)
        }
    }

    loadStore() {
        this.store.loadValues(this.store.agGridProps);
    }

    handleClear(e) {
        this.store.selectedOptions.clear();
        this.store.searchText = "";
        this.handleSubmit();
    }

    handleInvertSelection() {
        this.store.invertSelection();
        this.handleSubmit();
    }
    
    handleSubmit(e) {
        const { selectedOptions } = this.store

        const values = [...selectedOptions];

        this.props.onChange(values.length > 0 ? {
            values: values
        } : {});
    }

    handleChange = (value, isSelected) => {
        const { selectedOptions } = this.store;

        if (isSelected) {
            selectedOptions.add(value);
        } else {
            selectedOptions.delete(value);
        }
        this.handleSubmit();
    }

    handleSearch = (e) => {
        let options = this.props?.colDef?.cellRendererParams;
        let value = e.target.value;
        if (
          options &&
          options.columnTypeId &&
          String(value).includes(".") &&
          String(value).split(".")[1].length !== 0
        ) {
          if (options.columnTypeId == 22) {
            let decimals = String(value).includes(".") ? String(value).split(".")[1].length : 2;
            value = isNaN(value) ? value : (Number(value) / 100).toFixed(decimals + 2);
          } else if (
            !isNaN(value) &&
            options.columnTypeId == 10 &&
            options.columnOptions?.column_type == "percentage"
          ) {
            let decimals = String(value).includes(".") ? String(value).split(".")[1].length : 2;
            value = (Number(value) / 100).toFixed(decimals + 2);
          }
        }
        this.store.searchText = value;
    }

    handleSort = (e,isCountSorting=0) => {
        var block = this.store.values.shift();
        var no_block = this.store.values.shift();
        if (isCountSorting) {
          if (this.store.isCountSortAscending) {
            this.store.values = this.store.values.sort(
              (a, b) => +a.count - b.count
            );
            this.store.isCountSortAscending = 0;
          } else {
            this.store.values = this.store.values.sort(
              (a, b) => +b.count - a.count
            );
            this.store.isCountSortAscending = 1;
          }
        } else {
          if (this.store.isValueSortAscending) {
            this.store.values = this.store.values.sort(
              (a, b) =>
                (
                  "" + a[this.store.dataIndex]
                ).localeCompare(b[this.store.dataIndex])
            );
            this.store.isValueSortAscending = 0;
          } else {
            this.store.values = this.store.values.sort(
              (a, b) =>
                (
                  "" + b[this.store.dataIndex]
                ).localeCompare(a[this.store.dataIndex])
            );
            this.store.isValueSortAscending = 1;
          }
        }
        this.store.values.unshift(no_block);
        this.store.values.unshift(block);
    }

    render() {
        const {
            selectedOptions,
            filteredValues,
            isLoading,
            dataIndex
        } = this.store;

        if (isLoading) {
            return (<div style={{ padding: 20 }}>Loading...</div>);
        }
        return (
            <Grid container style={{ width: 220, padding: 10 }} >
                <Input placeholder="Search.." value={this.store.searchText} onChange={this.handleSearch} />
                <ListItem button
                    style={{ borderBottom: "1px solid #efefef", marginBottom: 2, paddingTop: 5 }}
                    className="cursor-default"
                >
                    <ListItemText
                        onClick={(e)=>this.handleSort(e,0)}
                    >
                        Sort
                    </ListItemText>
                    <Chip
                        onClick={(e)=>this.handleSort(e,1)}
                        size="small"
                        label="count"
                        clickable
                        color="primary"
                        variant="outlined"
                        className="cursor-default"
                    />
                </ListItem>
                <FixedSizeList height={300} width={200} itemSize={30} itemCount={filteredValues.length}>
                    {(props) => {
                        const { index, style } = props;

                        return <RenderRowObserver {...props} options={this.props?.colDef?.cellRendererParams} selectedOptions={selectedOptions} data={filteredValues[index]} dataIndex={dataIndex} onChange={this.handleChange} />;
                    }}
                </FixedSizeList>
                <Grid item xs={12}>
                    <Button
                        color="primary"
                        onClick={this.handleClear}
                        className="cursor-default"
                    >
                        Clear
                    </Button>
                    <Button
                        color="primary"
                        onClick={this.handleInvertSelection}
                        className="cursor-default"
                    >
                        Invert Selection
                    </Button>
                </Grid>
            </Grid>
        )
    }
}

function RenderRow({ options, index, style, selectedOptions, data, dataIndex, onChange }) {
    const value = data[dataIndex];
    const count = data["count"];
    const isValueSelected = selectedOptions.has(value);
    const optionRef = React.useRef(null);
    const [isTextOverFlown, setTextOverFlown] = React.useState(false);
    let optionName = value == "" ? "_blanks" : value;
    if (options && options.columnTypeId) {
      if (options.columnTypeId == 22) {
        let decimals =
          options.columnOptions && options.columnOptions.decimals
            ? options.columnOptions.decimals
            : 2;
        optionName = isNaN(optionName)
          ? optionName
          : (Number(value) * 100).toFixed(decimals - 2) + " %";
      } else if (
        !isNaN(optionName) &&
        options.columnTypeId == 10 &&
        options.columnOptions?.column_type == "percentage"
      ) {
        let decimals = String(optionName).includes(".")
          ? String(optionName).split(".")[1].length
          : 2;
        optionName = (Number(optionName) * 100).toFixed(decimals - 2) + " %";
      }
    }
    React.useEffect(() => {
        setTimeout(() => {
            if (optionRef?.current?.scrollWidth > optionRef?.current?.clientWidth) {
                setTextOverFlown(true);
            }
        }, 1);
    }, []);

    return (
        <ListItem
            className="cursor-default"
            button
            style={{
            ...style,
            ...{
                paddingLeft: 0,
            },
            }}
            key={index}
            onClick={() => {
                onChange(value, !isValueSelected);
            }}
        >
            <Checkbox
                value={value}
                checked={isValueSelected}
                className="cursor-default"
            />
            <StyledTooltip
                title={optionName}
                disableHoverListener={!isTextOverFlown}
            >
                <StyledSpan ref={optionRef}>
                    {optionName}
                </StyledSpan>
            </StyledTooltip>
            
            <Chip
                size="small"
                label={count}
                clickable
                color="primary"
                variant="outlined"
                className="cursor-default"
            />
        </ListItem>
    );
}
const RenderRowObserver = observer(RenderRow);

const StyledSpan = styled.span`
  flex: 1 1 auto;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
`;
export default observer(TextFilter); 


